import { useQueryClient } from 'react-query';

import {
  BROADCAST_CHANNEL,
  useBroadcastChannel,
} from '@hooks/useBroadcastChannel';

import { removeInactiveChatRoomQueries } from '@utils/chatRoomAvailability';

const ChatRoomInactiveSync = () => {
  const queryClient = useQueryClient();

  useBroadcastChannel<number[]>(
    BROADCAST_CHANNEL.CHAT_ROOM_INACTIVE,
    (inactiveChatRoomIds) => {
      removeInactiveChatRoomQueries(queryClient, inactiveChatRoomIds);
    }
  );

  return null;
};

export default ChatRoomInactiveSync;
